var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"id":"uv","src":"https://universalviewer.io/uv.html?manifest=https://honkoku.org/manifests/supvol10.json","frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }